import Layout from "./components/Layout";
import Chat from "../Tools/Chat";
import SignInForm from "../Account/components/SignInForm";
import useTargetUrl from "./utils/useTargetUrl";
import { useParams } from "react-router-dom";
import useCart from "./utils/useCart";

export default function Signin(){

    const { id } = useParams()

    const targetUrl = useTargetUrl()

    const { cart } = useCart()

    return (
        <Layout center>

            <SignInForm 
                successUrl={targetUrl}
                signUpUrl={`/courses/${id}/signup?category=${cart.category || ''}&status=${cart.status || ''}`}
            />

            <Chat />

        </Layout>
    );
}